import { render } from "./DesenhoApoio.vue?vue&type=template&id=1619b7c7&scoped=true"
import script from "./DesenhoApoio.vue?vue&type=script&lang=js"
export * from "./DesenhoApoio.vue?vue&type=script&lang=js"

import "./DesenhoApoio.vue?vue&type=style&index=0&id=1619b7c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1619b7c7"]])

export default __exports__